import { HStack, Icon, Text } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { SuggestionsButton } from '~/components/ui/tabs/Button';
import { SuggestionsButtonList } from '~/components/ui/tabs/ButtonList';
import { SuggestionBackButton } from '~/components/ui/tabs/components/BackButton';
import { StyledTab } from '~/components/ui/tabs/StyledTab';
import { ICONS } from '~/constants/icons';
import { CATEGORIES } from '@habity/constants';
import { useFilters } from '~/hooks/useFilters';
import { useHomesStore } from '~/store/useHomesStore';
import { getFilterArrayValues } from '@habity/services';
import { CategoryType } from '@habity/types';
import { getCategoryIcon } from '~/constants';

export const CategoriesTab = () => {
  const t = useTranslations('HomesList.Tabs.Category');
  return (
    <StyledTab>
      <HStack>
        <Icon as={ICONS.CATEGORY_ACTIVE} /> <Text>{t('title')}</Text>
      </HStack>
    </StyledTab>
  );
};

export const CategoriesTabContent = () => {
  const filters = useHomesStore((state) => state.filters);
  const { categories } = filters || {};
  const { performSearch } = useFilters();

  const onToggleCategory = (values: CategoryType[]) => {
    const newCategories = getFilterArrayValues(values, categories);
    performSearch({ filters: { categories: newCategories } });
  };

  return (
    <HStack mb={1} alignItems="center" overflowX="hidden">
      <SuggestionBackButton
        filterKeysToRemove={['areaIds', 'municipalityIds', 'streetIds']}
        clearLocations
      />
      <SuggestionsButtonList>
        {CATEGORIES.map((p, index) => (
          <SuggestionsButton
            key={index}
            icon={getCategoryIcon(p.values[0])}
            label={p.label}
            isActive={categories?.some((r) => p.values.includes(r))}
            onClick={() => onToggleCategory(p.values)}
          />
        ))}
      </SuggestionsButtonList>
    </HStack>
  );
};
